import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted, watch } from 'vue'
import { useRouter, useRoute, type RouteLocationRaw } from 'vue-router'
import { track } from '@/utils/analytics'
import { useDashboardNavigation, type DashboardNavItem } from '@/modules/dashboard/composables/useDashboardNavigation'
import i18n from '@/i18n'
import type { SidebarConfig } from '../types'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardSidebar',
  emits: ["update:config"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const router = useRouter()
const route = useRoute()

const currentRouteKey = computed(() => route?.name?.toString() || '')

const { navigationItems } = useDashboardNavigation()

const handleSubnavItemClick = (navItem: string, subnavItem: string) => {
  if (navItem === 'dashboard') {
    const item = navigationItems.value.find((nav) => nav.key === subnavItem)

    if (!item || item.isDisabled) {
      return
    }

    if (item.analyticsEvent) {
      track(item.analyticsEvent)
    }

    const routeConfig: RouteLocationRaw = { name: item.routeName }

    if (item.routeParams) {
      routeConfig.params = item.routeParams
    }

    if (item.routeQuery) {
      routeConfig.query = item.routeQuery
    }

    router.push(routeConfig)
  }
}

const isCurrentRoute = (item: DashboardNavItem): boolean => {
  const currentRoute = currentRouteKey.value

  // Handle looker routes
  if (item.routeName === 'dashboard.looker' && currentRoute === 'dashboard.looker') {
    const currentParams = route.params
    return currentParams.id === item.routeParams?.id
  }

  if (item.routeName === currentRoute) {
    return true
  }

  return false
}

// Transform navigation items to subnav format (without icons)
const items = computed(() => {
  return navigationItems.value.map((item: DashboardNavItem) => ({
    key: item.key,
    children: item.label,
    isCurrent: isCurrentRoute(item),
    dataTestId: item.testId || `dashboard-nav-${item.key}`,
    view: 'dashboard',
    // Don't include disabled items in clickable navigation
    ...(item.isDisabled && { disabled: true }),
  }))
})

const config = computed(
  (): SidebarConfig => ({
    action: {
      tooltip: '',
      menuItems: [],
      onClick: () => {
        /* no-op */
      },
    },
    title: i18n.t('dashboard.navbar.title'),
    items: items.value,
    handleSubnavItemClick,
    handleSubnavItemActionClick: () => {
      /* no-op */
    },
    handleGroupActionClick: () => {
      /* no-op */
    },
  }),
)

// Emit initial config and watch for changes
onMounted(() => {
  emit('update:config', config.value)
})

// Watch for changes and emit updates
watch(config, (newConfig) => {
  emit('update:config', newConfig)
})

return (_ctx: any,_cache: any) => {
  return _createCommentVNode(" Renderless component ")
}
}

})